<template>
    <div class="square_detial no-trans" v-loading="loading">
        <div class="square_detial_box">
            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/square_list">案源广场</router-link> > <span aria-current="page">详情</span>
            </div>
            <div class="detial_flex">
                <div class="inof_box1">
                    <div class="box1">
                        <div class="box1_tops">
                            <div class="tops_lefts">
                                <div class="tops_titles">
                                    {{ order_detial.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="tops_tages1">
                                    <div class="tage_flex">
                                        <div class="tege_title">时间：</div>
                                        <div class="tege_text">{{order_detial.created_at}}</div>
                                    </div>
                                    <div class="borders"></div>
                                    <div class="tage_flex">
                                        <div class="tege_title">费用：</div>
                                        <div class="tege_text">￥{{ order_detial.price }}</div>
                                    </div>
                                    <div class="borders"></div>
                                    <div class="tage_flex">
                                        <div class="tege_title">案件类型：</div>
                                        <div class="tege_text">{{ minx_get_case_type(order_detial.case_type)  }}</div>
                                    </div>
                                     <div class="borders"></div>
                                    <div class="tage_flex">
                                        <div class="tege_title">诉讼类型：</div>
                                        <div class="tege_text">{{ order_detial.proceed==1?'诉讼服务':order_detial.proceed==2?'非诉讼服务':'无' }}</div>
                                    </div>
                                </div>
                                <div class="tops_tages2">
                                    <div class="tages">{{ (order_detial.pro||{}).title }}</div>
                                </div>
                            </div>
                            <div class="tops_rights">
                                <div class="btns1" v-if="order_detial.can_apply==1">申请承接委托</div>
                                <div class="btns2" v-if="order_detial.can_apply==0" @click="handle_orderApply">申请承接委托</div>
                            </div>
                        </div>
                        <div class="box1_con">
                            <div class="con_titles">案情描述：</div>
                            <div class="con_consts">
                              {{ order_detial.mater_file||'' }}
                            </div>
                        </div>
                        <div class="box1_bom">
                            <div class="bom_lefts">
                                <img src="@/assets/img/index/comments_case/flie_url.png" alt="">
                                相关材料
                            </div>
                            <div class="bom_rights">
                                <div class="file_name" v-for="(item,index) in file_list" :key="index" @click="handle_file(item)">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="box2" v-if="order_detial.finish_message_time">
                        <div class="box2_user">
                            <div class="user_img">
                                <img src="@/assets/img/index/comments_case/user_img.png" alt="">
                            </div>
                            <div class="user_info">
                                <div class="names">李笑笑法律顾问</div>
                                <div class="times">
                                    发布于  {{ order_detial.finish_message_time }}
                                </div>
                            </div>
                        </div>
                        <div class="box2_com">
                            {{order_detial.finish_message}}
                        </div>
                    </div>
                    <div class="box3" v-if="order_detial.jianli">
                        <div class="box3_titles">
                            <div class="titles">{{ order_detial.jianli }}</div>
                            <div class="times">发布于 {{ order_detial.jianliTime }}</div>
                        </div>
                        <div class="box3_con">
                            {{ order_detial.jianliContent }}
                        </div>
                    </div>
                    <div class="box4">
                        <div class="title_box">
                            <div class="borders"></div>
                            <div class="titles">热门案源</div>
                        </div>
                        <div class="box_lists">
                            <div class="items" v-for="(item,index) in lists" :key="index" @click="handle_path(item)">
                                <div class="items_imgs">
                                    <img :src="(item.pro||{}).thumb" alt="">
                                </div>
                                <div class="item_info">
                                    <div class="item_top">
                                        <div class="titles">
                                            {{ item.title }}
                                            <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                        </div>
                                        <div class="item_tage">
                                            <div class="tages">{{(item.pro||{}).title}}</div>
                                        </div>
                                    </div>
                                    <div class="item_bom">
                                        <div class="user_img">
                                            <div class="imgs">
                                                <img src="@/assets/img/index/legal/user_img.png" alt="">
                                            </div>
                                            <div class="user_name">{{ item.user.nickname||'用户昵称' }}</div>
                                        </div>
                                        <div class="see_num">
                                            <img src="@/assets/img/index/home/see.png" alt="">
                                            {{item.view}}看过
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="">
                    <case_new ref="case_new"></case_new>
                </div>
            </div>
        </div>
        <prompt ref="prompt" @handle_orderApply_end="handle_orderApply_end"></prompt>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import case_new from  '@/components/case_source_square/case_new.vue'//右边
import prompt from  '@/components/case_source_square/prompt.vue'//提示
 

export default {
    components: {
        case_new,
        prompt
    },
    name: "homes",
    data() {
        return {
            loading:false,
            order_detial:{},
            file_list:[],
            lists:[],
          
        }
    },
    computed: {
       
    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                    
                this.get_list()
                this.get_detial()

            },
            immediate: true,
            deep: true
        },
    },
    created() {
       
    },
    methods: {
        handle_path(item){
            this.$router.replace({
                path:'/square_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_detial(){
            this.loading=true
            this.$api("caseSquareInfo", {
               id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('案源详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data
                    this.file_list=[]
                    if(res.data.prove_imgs){
                        let list=JSON.parse(res.data.prove_imgs) 
                        list.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }
                    if(res.data.other_imgs){
                        let list=JSON.parse(res.data.other_imgs)
                        list.forEach((e)=>{
                            this.file_list.push(e)
                        })
                    }
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_orderApply(){
            if(this.order_detial.proceed==2){
                this.$refs.prompt.handle_open2()
            }else{
            this.handle_orderApply_end2({price:0})
                
            }   
        },
        handle_orderApply_end(data){
            this.handle_orderApply_end2(data)

            // this.loading=true
            // this.$api("orderReceive", {
            //     order_id:this.$route.query.id,
			// }, "get").then((res) => {
            //     this.loading = false
            //     console.log('申请承接委托',res)
            //     if (res.code == 1) {
            //         // alertSucc('申请成功')
                 
                   
            //     } else {
            //         alertErr(res.msg)
            //     }
            // });
        },
        handle_orderApply_end2(data){
            this.loading=true
            this.$api("orderApply", {
               id:this.$route.query.id,
               price:data.price,
			}, "post").then((res) => {
                this.loading = false
                console.log('申请承接委托',res)
                if (res.code == 1) {
                    // alertSucc('申请成功')
                    this.$refs.prompt.handle_open3()
                    this.get_detial()
                   
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_file(item){
            window.open(item.path)
        },  
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        get_list(){
            this.loading=true
            this.$api("caseSquare", {
                page:1,
                limit:10,
                status:20,

			}, "get").then((res) => {
                this.loading = false
                console.log('案源广场',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.square_detial{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .square_detial_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .detial_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .inof_box1{
                width: 1000px;
                .box1{
                    width: 100%;
                    background-color: #fff;
                    padding: 32px 32px 38px 32px;
                    .box1_tops{
                        display: flex;
                        // align-items: center;
                        justify-content: space-between;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #EEEEEE;
                        .tops_lefts{
                            .tops_titles{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;
                                img{
                                    width: 14px;
                                    height: 18px;
                                    margin-left: 10px;
                                }
                            }
                            .tops_tages1{
                                display: flex;
                                align-items: center;
                                padding-top: 12px;
                                .tage_flex{
                                    display: flex;
                                    align-items: center;
                                    .tege_title{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                    }
                                    .tege_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                    
                                    }
                                }
                                .borders{
                                    width: 0;
                                    height: 15px;
                                    border-left: 1px solid #999999;
                                    margin: 0 20px;
                                }
                            }
                            .tops_tages2{
                                display: flex;
                                align-items: center;
                                padding-top: 12px;
                                .tages{
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                 }
                            }
                        }
                        .tops_rights{
                            .btns1{
                                background: #BEBEBE;
                                border-radius: 4px 4px 4px 4px;
                                padding: 11px 25px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                            }
                            .btns2{
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                padding: 11px 25px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                            }
                        }
                    }
                    .box1_con{
                        padding-top: 24px;
                        .con_titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .con_consts{
                            padding-top: 12px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            line-height: 32px;
                            padding-bottom: 32px;
                            border-bottom: 1px solid #D9D9D9;
                        }
                    }
                    .box1_bom{
                        display: flex;
                        padding-top: 28px;
                        // align-items: center;
                        .bom_lefts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            img{
                                width: 16px;
                            }
                        }
                        .bom_rights{
                            padding-left: 60px;
                            .file_name{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-bottom: 15px;
                                cursor: pointer;
                            }
                        }

                    }
                }
                .box2{
                    width: 1000px;
                    min-height: 291px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding: 40px 40px 29px 40px;
                    margin-top: 24px;
                    .box2_user{
                        display: flex;
                        align-items: center;
                        .user_img{
                            width: 64px;
                            height: 64px;
                            flex-shrink: 0;
                            img{
                                width: 64px;
                                height: 64px;
                            }
                        }
                        .user_info{
                            flex: 1;
                            padding-left: 24px;
                            height: 64px;
                            display: flex;
                            flex-wrap: wrap;
                            align-content: space-between;
                            .names{
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                            }
                            .times{
                                width: 100%;

                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                            }
                        }
                    }
                    .box2_com{
                        padding-top: 34px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 32px;
                    }
                }
                .box3{
                    padding: 43px 40px 25px 40px;
                    background: #FFFFFF;
                    margin-top: 20px;
                    .box3_titles{
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;

                        }
                        .times{
                            padding-top: 11px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;

                        }
                    }
                    .box3_con{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        padding-top: 24px;
                    }
                }
                .box4{
                    background-color: #FFFFFF;
                    margin-top: 20px;
                    .title_box{
                        padding-top: 24px;
                        display: flex;
                        align-items: center;
                        padding-bottom: 46px;

                        .borders{
                            width: 4px;
                            height: 22px;
                            background: #377CFD;
                            border-radius: 3px 3px 3px 3px;
                        }
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 20px;
                            color: #333333;
                            padding-left: 32px;
                        }
                    }
                    .box_lists{
                        padding: 0 32px;
                        .items{
                            padding-bottom: 32px;
                            border-bottom: 1px solid #EEEEEE;
                            display: flex;
                            align-items: center;
                            margin-bottom: 32px;
                            .items_imgs{
                                flex-shrink: 0;
                                width: 184px;
                                height: 184px;
                               img{
                                width: 184px;
                                height: 184px;
                               } 
                            }
                            .item_info{
                                padding-left: 28px;
                                height: 184px;
                                display: flex;
                                align-content: space-between;
                                flex-wrap: wrap;
                                flex: 1;
                                .item_top{
                                    width: 100%;
                                    .titles{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 18px;
                                        color: #333333;
                                        img{
                                            width: 14px;
                                            height: 18px;
                                            margin-left: 10px;
                                        }
                                    }
                                    .item_tage{
                                        display: flex;
                                        padding-top: 24px;
                                        .tages{
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 12px;
                                            color: #FFAA00;
                                            padding: 4px 12px;
                                            background: #FDF6EC;
                                            border-radius: 3px 3px 3px 3px;
                                            border: 1px solid #FFAA00;
                                        }
                                       
                                    }
                                }
                                .item_bom{
                                    width: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    .user_img{
                                        display: flex;
                                        align-items: center;
                                        .imgs{
                                            img{
                                                width: 32px;
                                                height: 32px;
                                            }
                                        }
                                        .user_name{
                                            padding-left: 10px;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 16px;
                                            color: #333333;

                                        }
                                    }
                                    .see_num{
                                        display: flex;
                                        align-items: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                        img{
                                            width: 25px;
                                            margin-right: 8px;
                                        }
                                   }
                                }
                               
                            }
                        }
                    }
                }
            }
         
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .square_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .square_detial.no-trans .square_detial_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .square_detial.no-trans .square_detial_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .square_detial.no-trans .square_detial_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 {
        padding: 16px 16px 16px 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_titles {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_titles img {
        width: 14px;
        height: 18px;
        margin-left: 10px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages1 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 12px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages1 .tage_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages1 .tage_flex .tege_title {
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages1 .tage_flex .tege_text {
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages1 .borders {
        height: 15px;
        margin: 0 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 12px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_lefts .tops_tages2 .tages {
        padding: 4px 12px;
        border-radius: 3px 3px 3px 3px;
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_rights .btns1 {
        border-radius: 4px 4px 4px 4px;
        padding: 11px 16px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_tops .tops_rights .btns2 {
        border-radius: 4px 4px 4px 4px;
        padding: 11px 16px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_con {
        padding-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_con .con_titles {
        font-size: 18px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_con .con_consts {
        padding-top: 12px;
        font-size: 14px;
        line-height: 32px;
        padding-bottom: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_bom {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_bom .bom_lefts {
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_bom .bom_lefts img {
        width: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_bom .bom_rights {
        padding-left: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box1 .box1_bom .bom_rights .file_name {
        font-size: 14px;
        margin-bottom: 15px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        padding: 16px 16px 16px 16px;
        margin-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user .user_img {
        width: 64px;
        height: 64px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user .user_img img {
        width: 64px;
        height: 64px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user .user_info {
        padding-left: 16px;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user .user_info .names {
        font-size: 24px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_user .user_info .times {
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box2 .box2_com {
        padding-top: 16px;
        font-size: 14px;
        line-height: 32px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box3 {
        padding: 16px 16px 16px 16px;
        margin-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box3 .box3_titles .titles {
        font-size: 24px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box3 .box3_titles .times {
        padding-top: 11px;
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box3 .box3_con {
        font-size: 14px;
        padding-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 {
        margin-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .title_box {
        padding-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .title_box .borders {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .title_box .titles {
        font-size: 20px;
        padding-left: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists {
        padding: 0 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .items_imgs {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .items_imgs img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info {
        padding-left: 16px;
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_top .titles {
        font-size: 18px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_top .titles img {
        width: 14px;
        height: 18px;
        margin-left: 10px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_top .item_tage {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_top .item_tage .tages {
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 3px 3px 3px 3px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom .user_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom .user_img .imgs img {
        width: 32px;
        height: 32px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom .user_img .user_name {
        padding-left: 10px;
        font-size: 16px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom .see_num {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .square_detial.no-trans .square_detial_box .detial_flex .inof_box1 .box4 .box_lists .items .item_info .item_bom .see_num img {
        width: 25px;
        margin-right: 8px;
    }
}
</style>
